import React, { useEffect, useState, useRef } from "react";
import Styles from "../../styles/session/session.module.scss";
import Navbar from "../../components/Navbar";
import Create from "../../assets/session/create.png";
import Duplicate from "../../assets/session/dup-white.png";
import Delete from "../../assets/session/delete.png";
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteSession, duplicateApi, getSession } from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/deletepopup.png";
import Swal from "sweetalert2";
import InfiniteScroll from "react-infinite-scroll-component";
import { toggle } from "../../redux";
import Duplicate_Image_URL from "../../assets/session/duplicate_dark.png";
import { FaSearch } from "react-icons/fa";

const capitalizeEachWord = (string) => {
  if (!string) return "";
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
const LIMIT = 15;

const ListSession = () => {
  const { sessions, isLoading } = useSelector((state) => state.sessions);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [displayedSessions, setDisplayedSessions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const selectedSessionsRef = useRef([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("latest");

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  const fetchSessions = async (
    pageNum = page,
    query = "",
    sort = sortOrder
  ) => {
    if (loading) return;

    try {
      setLoading(true);
      const newSessions = await getSession(false, pageNum, LIMIT, query, sort);

      if (newSessions && Array.isArray(newSessions) && newSessions.length > 0) {
        setDisplayedSessions((prev) => [...prev, ...newSessions]);
        setPage(pageNum + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSessions();
  }, []);

  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);

    try {
      if (query.trim() === "") {
        setDisplayedSessions([]);
        setPage(1);
        setHasMore(true);
        setTimeout(() => {
          fetchSessions(1, "", sort);
        }, 1);
      } else {
        const newSessions = await getSession(false, 1, -1, query, sort);
        if (Array.isArray(newSessions)) {
          setDisplayedSessions(newSessions);
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  useEffect(() => {
    const hasInvalidFormat = sessions.some((session) =>
      session.formats?.some((fmt) => !fmt?.format?.name)
    );

    if (hasInvalidFormat) {
      console.warn("Invalid format name detected! Refreshing page...");
      window.location.reload();
    }
  }, [sessions]);

  const handleViewFormat = (sessionId) => {
    navigate(`${adminRoutes.viewSession.replace(":sessionId", sessionId)}`);
  };

  const handleFormatSession = (sessionId) => {
    navigate(`${adminRoutes.listFormat.replace(":sessionId", sessionId)}`);
  };

  const handleAssignFormat = (sessionId) => {
    navigate(
      `${adminRoutes.assignFormatFirst.replace(":sessionId", sessionId)}`
    );
  };

  const handleDelete = (id) => {
    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button 
            id="customCloseButton" 
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img 
              src=${Close_Button} 
              alt="Close" 
              style="width: 40px; height: 40px;"
            />
          </button>
          <img 
            src=${Suceess} 
            alt="Success" 
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;" 
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
          <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
            Do you really want to delete these details? This process cannot be undone.
          </p>
          <button 
            id="cancel" 
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button 
            id="delete" 
            style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Delete
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });
        deleteButton.addEventListener("click", async () => {
          Swal.close();
          const success = await deleteSession(id);
          if (success) {
            window.location.reload(adminRoutes.listSession);
          }
        });
        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  const handleCreateNewSession = () => {
    navigate(adminRoutes.createSession);
  };

  const handleCheckboxChange = (sessionId, isChecked) => {
    if (isChecked) {
      selectedSessionsRef.current = [...selectedSessionsRef.current, sessionId];
    } else {
      selectedSessionsRef.current = selectedSessionsRef.current.filter(
        (id) => id !== sessionId
      );
    }
  };

  const handleDuplicate = () => {
    if (!sessions || sessions.length === 0) {
      console.error("Sessions data is not available!");
      return;
    }

    const closeButtonStyles = `
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    outline: none;
  `;

    const containerStyles = `
    position: relative;
    padding: 0;
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 0;
    padding: 0; 
    border: none; 
  `;

    const headerStyles = `
  background: radial-gradient(798.09% 100% at 0% 49.32%, #E27908 0%, #7C4205 100%);
  color: #F9FBFC;
  text-align: left;
 font-family: vanguard_cf_boldbold;
   padding: 15px 20px; 
  font-size: 22px;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  margin: 0; 
  border: none; 
`;

    const tableHTML = `
    <div style="${containerStyles}">
      <div style="${headerStyles}">DUPLICATE THE LISTED ITEMS</div>

      <button style="${closeButtonStyles}" id="customCloseButton">
        <img src="${Close_Button}" alt="Close" style="width: 30px; height: 30px; border: none; outline: none;">
      </button>

      <div style="max-height: 260px; overflow-y: auto; border:none;">
        <table style="width: 100%; border-collapse: collapse; text-align: left;">
         <thead style="background-color: #F5A623; color: #fff; position: sticky; top: 0; padding: 0; margin: 0;">
            <tr>
              <th style="padding: 10px; text-align: center; font-family:gothambold;border:none;outline:none;"></th>
              <th style="padding: 10px;border:none;outline:none; font-family: 'gothambold';">Session Code</th>
              <th style="padding: 10px;border:none;outline:none;font-family: 'gothambold';">Session Name</th>
              <th style="padding: 10px;border:none;outline:none;font-family: 'gothambold';">Formats</th>
            </tr>
          </thead>
          <tbody>
            ${sessions
              .map(
                (row, index) => `
                <tr style="background-color: ${
                  index % 2 === 0 ? "rgba(31, 31, 31, 0.05);" : "#ffffff"
                };">
                  <td style="padding: 10px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; text-align: center;">
                    <input type="checkbox" data-session-id="${
                      row?._id
                    }" class="session-checkbox" />
                  </td>
                  <td style="padding: 10px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; color: #000;font-family: 'gotham_bookregular'; font-size: 0.85rem;">
                    ${row.code ?? ""}
                  </td>
                <td style="padding: 10px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; color: #000; font-family: 'gotham_bookregular';font-size: 0.85rem;">
          ${row.name ?? ""}
           </td>

                  <td style="padding: 10px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; color: #000;font-family: 'gotham_bookregular';font-size: 0.85rem;">
                    ${
                      Array.isArray(row.formats) && row.formats.length > 2
                        ? row.formats
                            .slice(0, 2)
                            .map(
                              (format) =>
                                `<span style="display: inline-block; padding: 5px 10px; margin: 3px; border: 1px solid #ccc; border-radius: 12px; background-color: #f8f8f8;">${
                                  format?.format?.name || "Unknown"
                                }</span>`
                            )
                            .join("") +
                          `<span style="display: inline-block; padding: 5px 10px; margin: 3px; border: 1px solid #ccc; border-radius: 12px; background-color: #f8f8f8;">Others</span>`
                        : Array.isArray(row.formats)
                        ? row.formats
                            .map(
                              (format) =>
                                `<span style="display: inline-block; padding: 5px 10px; margin: 3px; border: 1px solid #ccc; border-radius: 12px; background-color: #f8f8f8;">${
                                  format?.format?.name || "Unknown"
                                }</span>`
                            )
                            .join("")
                        : "N/A"
                    }
                  </td>
                </tr>
              `
              )
              .join("")}
          </tbody>
        </table>
      </div> <!-- End of Scrollable Container -->

      <div style="text-align: center; margin: 20px;">
        <button id="duplicateSelectedButton" style="display: inline-flex; height: 40px; padding: 10px 25px; justify-content: center; align-items: center; background-color: transparent; border: 1px solid #F79328; color: #21211C; border-radius: 8px; cursor: pointer; font-family: 'gothambold';">
          <img src=${Duplicate_Image_URL} alt="Duplicate" style="width: 20px; height: 20px; margin-right: 10px;">
          <span>Duplicate</span>
        </button>
      </div>
    </div>
  `;

    Swal.fire({
      html: tableHTML,
      showConfirmButton: false,
      width: "1000px",
      background: "none",
      backdrop: true,
      customClass: {
        popup: "no-padding-modal", // Custom class to remove extra padding
      },
      didOpen: () => {
        const checkboxes = document.querySelectorAll(".session-checkbox");

        checkboxes.forEach((checkbox) => {
          const sessionId = checkbox.getAttribute("data-session-id");
          checkbox.checked = selectedSessionsRef.current.includes(sessionId);

          checkbox.addEventListener("change", (e) => {
            handleCheckboxChange(sessionId, e.target.checked);
          });
        });

        // Handle duplicate button click
        document
          .getElementById("duplicateSelectedButton")
          .addEventListener("click", async () => {
            try {
              console.log(
                "Duplicating sessions with IDs:",
                selectedSessionsRef
              );
              if (selectedSessionsRef.current.length > 0) {
                await duplicateApi(selectedSessionsRef.current);
                Swal.close();
                window.location.reload();
              } else {
                alert("No sessions selected!");
              }
            } catch (error) {
              console.error("Error duplicating sessions:", error);
              alert("Failed to duplicate sessions.");
            }
          });

        // Handle close button
        document
          .getElementById("customCloseButton")
          .addEventListener("click", () => Swal.close());
      },
    });
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.session_list_container}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.dashboard}>HOME / </Link>{" "}
          <span>ALL SESSIONS</span>
        </h2>
        <div className={Styles.table_container_main}>
          <div className={Styles.table_container}>
            <div className={Styles.table_container_heading}>
              <div className={Styles.table_container_headingone}>
                <h3>SESSIONS &nbsp;LIST</h3>
              </div>
              <div className={Styles.table_container_headingtwo}>
                <select
                  className={Styles.sortselect}
                  value={sortOrder}
                  onChange={(e) => {
                    const selected = e.target.value;
                    setSortOrder(selected);
                    setDisplayedSessions([]);
                    setPage(1);
                    setHasMore(true);

                    if (searchQuery.trim()) {
                      handleSearch(
                        { target: { value: searchQuery } },
                        selected
                      );
                    } else {
                      fetchSessions(1, searchQuery, selected);
                    }
                  }}
                >
                  <option value="latest">Latest Sessions</option>
                  <option value="oldest">Oldest Sessions</option>
                  <option value="asc">A - Z (Sort in ascending order)</option>
                  <option value="desc">Z - A (Sort in descending order)</option>
                </select>

                <div
                  className={`${Styles.searchContainerchildtwo} ${
                    searchQuery ? Styles.active : ""
                  }`}
                >
                  <FaSearch className={Styles.searchIcon} />
                  <input
                    type="text"
                    className={Styles.searchInput}
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>

                <div
                  className={Styles.duplicate}
                  onClick={handleDuplicate}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={Duplicate}
                    alt="Duplicate Icon"
                    className={Styles.icon}
                  />
                  Duplicate
                </div>
                <div
                  className={Styles.create_new_session}
                  onClick={handleCreateNewSession}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={Create}
                    alt="Duplicate Icon"
                    className={Styles.icon}
                  />
                  Create New Session
                </div>
              </div>
            </div>

            <div className={Styles.tableFixedHeader}>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "10vw" }}>Session Code</th>
                    <th style={{ width: "18vw" }}>Session Name</th>
                    <th style={{ width: "22vw" }}>Formats</th>
                    <th style={{ width: "37vw" }}>Actions</th>
                  </tr>
                </thead>
              </table>

              <div id="scrollableDiv" className={Styles.scrollableContainer}>
                <InfiniteScroll
                  dataLength={displayedSessions.length}
                  next={fetchSessions}
                  hasMore={hasMore}
                  loader={
                   <></>
                  }
                  endMessage={
                    <p style={{  textAlign: "center",
                      padding: "10px",
                      color: "#f3f3f6",
                      fontFamily:"gotham_bookregular",}}>
                    </p>
                  }
                  scrollableTarget="scrollableDiv"
                  scrollThreshold={0.8}
                >
                  <table>
                    <tbody>
                      {displayedSessions.length === 0 ? (
                        <tr>
                          <td
                            colSpan="4"
                            style={{  textAlign: "center",
                              padding: "10px",
                              color: "#f3f3f6",
                              fontFamily: "vanguard_cf_regular",}}
                          >
                            {loading
                              ? "Loading sessions..."
                              : "No sessions available"}
                          </td>
                        </tr>
                      ) : (
                        displayedSessions.map((session, index) => (
                          <tr key={`${session?._id || ""}-${index}`}>
                            <td style={{ width: "11vw" }}>
                              {session?.code ?? "N/A"}
                            </td>
                            <td style={{ width: "20vw" }}>
                              {session?.name
                                ? capitalizeEachWord(session.name)
                                : "N/A"}
                            </td>
                            <td
                              style={{ width: "25vw" }}
                              className={Styles.table_format}
                            >
                              {session.formats && session.formats.length > 0 ? (
                                <>
                                  {session.formats
                                    .slice(0, 3)
                                    .map((fmt, idx) => (
                                      <span
                                        key={idx}
                                        className={Styles.format_chip}
                                      >
                                        {fmt?.format?.name || "Unknown"}
                                      </span>
                                    ))}
                                  {session.formats.length > 3 && (
                                    <span className={Styles.format_chip}>
                                      Others
                                    </span>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                            </td>
                            <td
                              style={{ width: "30vw" }}
                              className={Styles.action_buttons}
                            >
                              <button
                                className={Styles.view}
                                onClick={() => handleViewFormat(session._id)}
                                style={{ cursor: "pointer" }}
                              >
                                View Session
                              </button>
                              <button
                                className={Styles.format}
                                onClick={() => handleFormatSession(session._id)}
                                style={{ cursor: "pointer" }}
                              >
                                View Format
                              </button>
                              <button
                                className={Styles.assign}
                                onClick={() => handleAssignFormat(session._id)}
                                style={{ cursor: "pointer" }}
                              >
                                Assign Format
                              </button>
                              <button
                                className={Styles.delete}
                                onClick={() => handleDelete(session._id)}
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  src={Delete}
                                  alt="Delete Icon"
                                  className={Styles.delete_icon}
                                />
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>

                  {/* Debug information */}
                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      color: "#f3f3f6",
                      fontFamily: "vanguard_cf_regular",
                    }}
                  >
                    {loading
                      ? "Loading more content..."
                      : hasMore
                      ? "Scroll to load more"
                      : ""}
                  </div>
                </InfiniteScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListSession;
